import { ButtonLink, Text } from '../../common/components';
import { t } from '../../common/i18n';
import { CAR_APP_ICON } from '../config/catalogConfig';
import { partnerDetailPath } from '../hooks/usePreviewToken';
import { ServicePartner } from '../types';

const namespace = 'OtherServices';

interface CarAppBannerProps {
  partner: ServicePartner;
  preview?: string | null;
}

/**
 * Banner aplikace eVlastníci Auto – samostatná (interní) aplikace pro vlastníky: přehled aut,
 * spotřeba, hlídání termínů, kniha jízd. Pro klienty eVlastníků je prémiová verze zdarma.
 * Vykresluje se místo karty služby, aby v katalogu nezapadla; tlačítko vede do detailu
 * nabídky, kde zájemce nechá kontakt (sběr zájemců před spuštěním).
 */
export const CarAppBanner: React.FC<CarAppBannerProps> = ({ partner, preview = null }) => {
  if (partner.offers.length === 0) return null;

  const features = t('CarApp.features', namespace, { returnObjects: true }) as unknown as string[];

  return (
    <section className="CarAppBanner">
      <img src={CAR_APP_ICON} alt="" className="CarAppBanner__icon" />
      <div className="CarAppBanner__body">
        <Text as="div" size="body-xs" weight="600" className="CarAppBanner__eyebrow">
          {t('CarApp.eyebrow', namespace)}
        </Text>
        <Text as="h2" size="h3" color="Neutral100">
          {t('CarApp.title', namespace)}
        </Text>
        <Text as="p" size="body-small" className="CarAppBanner__text">
          {t('CarApp.text', namespace)}
        </Text>
        <ul className="FactChips FactChips--onDark">
          {features.map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
      </div>
      <div className="CarAppBanner__cta">
        <Text as="div" size="body-small" weight="600" className="CarAppBanner__free">
          {t('CarApp.free', namespace)}
        </Text>
        <ButtonLink to={partnerDetailPath(partner.slug, preview)} title={t('CarApp.action', namespace)} variant="primary" />
      </div>
    </section>
  );
};

export default CarAppBanner;
